/**
 *
 * Carousel
 *
 */

import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import _classNames from 'classnames';
import _get from 'lodash/get';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import './styles.css';
import ArrowLeft from 'components/Carousel/images/arrow-left.svg';
import ArrowRight from 'components/Carousel/images/arrow-right.svg';

const CustomLeftArrow = ({ onClick, small }) => (
  <button
    type="button"
    onClick={onClick}
    className={
      small
        ? 'cm-resources-custom-left-arrow-small'
        : 'cm-resources-custom-left-arrow'
    }
  >
    <img src={ArrowLeft} alt="Arrow Left" />
  </button>
);
const CustomRightArrow = ({ onClick, small, arrowRightClickHandler }) => (
  <button
    type="button"
    onClick={() => {
      onClick();
      arrowRightClickHandler();
    }}
    className={
      small
        ? 'cm-resources-custom-right-arrow-small'
        : 'cm-resources-custom-right-arrow'
    }
  >
    <img src={ArrowRight} alt="Arrow Right" />
  </button>
);

const CustomDot = ({ onClick, active }) => (
  <li>
    <button
      type="button"
      aria-label="cm-carousel-dot"
      onClick={onClick}
      className={
        active
          ? 'cm-resources-custom-dot cm-resources-custom-dot-active'
          : 'cm-resources-custom-dot'
      }
    />
  </li>
);

function ResourcesCarousel(props) {
  const {
    children,
    slidesToSlide,
    swipeable,
    responsive,
    infinite,
    partialVisible,
    beforeChange,
    arrows,
    small,
    isSmallCard,
    renderDotsOutside,
    showDots,
    setRef,
    arrowRightClickHandler,
  } = props;
  const carouselRef = useRef();
  const [shouldShowDots, setShowDots] = useState(false);

  const numItems = children.length;

  useEffect(() => {
    if (showDots && carouselRef.current) {
      setShowDots(
        _get(carouselRef, 'current.state.containerWidth', 0) >
          numItems * 18 + 24,
      );
    }
  }, [numItems, showDots]);

  return (
    <Carousel
      ref={el => {
        if (setRef) setRef(el);
        carouselRef.current = el;
      }}
      additionalTransform={0}
      arrows={arrows}
      beforeChange={beforeChange}
      centerMode={false}
      customLeftArrow={<CustomLeftArrow small={small} />}
      customRightArrow={
        <CustomRightArrow
          small={small}
          arrowRightClickHandler={arrowRightClickHandler}
        />
      }
      containerClass={_classNames('cm-resources-carousel-container', {
        'cm-resources-carousel-small-card-container': isSmallCard,
      })}
      dotListClass="cm-resources-carousel-dot-list"
      draggable
      focusOnSelect={false}
      itemClass="cm-resources-carousel-item"
      keyBoardControl
      partialVisible={partialVisible}
      minimumTouchDrag={80}
      renderDotsOutside={renderDotsOutside}
      showDots={shouldShowDots}
      customDot={<CustomDot />}
      sliderClass="cm-resources-carousel-slider"
      slidesToSlide={slidesToSlide}
      swipeable={swipeable}
      infinite={infinite}
      responsive={
        responsive || {
          desktop: {
            breakpoint: {
              max: 3000,
              min: 1024,
            },
            items: 4,
            partialVisibilityGutter: 40,
          },
          mobile: {
            breakpoint: {
              max: 464,
              min: 0,
            },
            items: 2,
            partialVisibilityGutter: 30,
          },
          tablet: {
            breakpoint: {
              max: 1024,
              min: 464,
            },
            items: 3,
            partialVisibilityGutter: 30,
          },
        }
      }
    >
      {children}
    </Carousel>
  );
}

ResourcesCarousel.propTypes = {
  children: PropTypes.node.isRequired,
  slidesToSlide: PropTypes.number,
  swipeable: PropTypes.bool,
  responsive: PropTypes.object,
  arrows: PropTypes.bool,
  partialVisible: PropTypes.bool,
  infinite: PropTypes.bool,
  small: PropTypes.bool,
  isSmallCard: PropTypes.bool,
  renderDotsOutside: PropTypes.bool,
  showDots: PropTypes.bool,
  setRef: PropTypes.func,
  beforeChange: PropTypes.func,
  arrowRightClickHandler: PropTypes.func,
};

ResourcesCarousel.defaultProps = {
  swipeable: true,
  infinite: false,
  arrows: true,
  partialVisible: false,
  small: false,
  isSmallCard: false,
  renderDotsOutside: false,
  showDots: false,
  arrowRightClickHandler: () => {},
  beforeChange: () => {},
};

const CustomArrowPropTypes = {
  onClick: PropTypes.func,
  small: PropTypes.bool,
};

CustomLeftArrow.propTypes = CustomArrowPropTypes;
CustomRightArrow.propTypes = {
  ...CustomArrowPropTypes,
  arrowRightClickHandler: PropTypes.func,
};

export default ResourcesCarousel;
